import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { saveLoginUserData, signOutRequest, updateUserData } from "../store/Actions/authAction.js";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import lottie from "lottie-web";
import { loadingAnimation } from "../constant/imagePath.js";

export const AuthProvider = ({ children }) => {
  const auth = getAuth();
  const dispatch = useDispatch();
  const [pending, setPending] = useState(true);

  useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector(".animationContainer"),
      animationData: loadingAnimation,
    });

    onAuthStateChanged(auth, async(user) => {
      if (user) {
        console.log(user)
        const customClaim = await user.getIdTokenResult();
        const role = customClaim.claims.role;
        dispatch(saveLoginUserData(role));
      } else {
        dispatch(signOutRequest());
      }
      setPending(false);
    });
  }, []);

  if (pending) {
    return <div className="animationContainer" />;
  }

  return <>{children}</>;
};
